import { useQuery } from "react-query";
import axiosInstance from "../../../../common/axiosInstance";

// Modify the hook to accept a restaurantId and adjust the query key accordingly
export const useFetchStoreInfo = (storeId: string | null | undefined ) => {
    return useQuery(['storeInfo', storeId], () => getStoreData(storeId), {
        enabled: !!storeId // Fetch data only if restaurantId is present
    });
};

const getStoreData = async (storeId: string | null | undefined) => {
    if (!storeId) {
        throw new Error("storeId is required");
    }
    const response = await axiosInstance.get(`https://api.menufy.link/restaurantBackend/stores/info?storeId=${storeId}`);
    return response.data;
};
